export const CHAT_NAME = "AI Assistant"

export const CHAT_INCENTIVE = "How can I help you?"

export const LOADING_TEXT = "Loading..."
